import React from 'react';
import {
  fetchGenericIllustrations,
  IllustrationType
} from '@gjensidige/se-content-helpers';

import { WelcomeBack } from '../components/Login/WelcomeBack';
import { AppConstants } from '../utils/AppConstants';
import { RoutingHelper } from '../utils/RoutingHelper';
import { TextHelper } from '../utils/TextHelper';
import { Text } from '@gjensidige/builders-components';

interface WelcomeBackContainerProps {
  product: string;
  isLoggedIn: boolean;
  redirectPage: string;
}
export const WelcomeBackContainer: React.FC<WelcomeBackContainerProps> = (
  {
    product, 
    isLoggedIn, 
    redirectPage
  }: WelcomeBackContainerProps
) => {
  const gotToLogin = () => {
    const loginurl = RoutingHelper.getLogInUrl(product, isLoggedIn, redirectPage);
    if (loginurl) {
      window.location.href = loginurl;
    }
  };
  return (
    <div>
      <WelcomeBack
        welcomeMessage={TextHelper.getWelcomeBackMessage(redirectPage)}
        criticalButtonAction={gotToLogin}
        criticalButtonLabel={AppConstants.getAppText(
          'webshop.summary.welcome.bankIdLoginButton'
        )}
      />
    </div>
  );
};
